import { Box, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import type { CSSProperties } from 'react';
import clsx from 'clsx';
import React from "react";

type StyleProps = {
  flex: CSSProperties["flex"],
  imageRotate: CSSProperties["rotate"],
  backgroundColor: CSSProperties["backgroundColor"]
}

const useStyles = makeStyles((theme: any) => ({
  paper: {
    padding: "24px 24px 26px 32px",
    color: "#3e3d4a",
    height: "120px",
    border: "solid 1px #cfd8dc",
    minWidth: 0,
    // Below lg the boxes stack: size to content so wrapped titles and values never collide.
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
      padding: theme.spacing(2),
    },
  },
  surface: ({ flex: flexValue, backgroundColor }: StyleProps) => ({
    flex: flexValue,
    backgroundColor
  }),
  image: ({ imageRotate }: StyleProps) => ({
    rotate: imageRotate
  }),
  titleContainer: {
    display: "flex", justifyContent: "space-between", gap: theme.spacing(1)
  },
  title: {
    fontSize: "16px !important"
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: "30px",
    rowGap: theme.spacing(0.5),
  },
  value: {
    color: "#1a1a2d", fontWeight: "bold", fontSize: "25px", overflowWrap: "anywhere"
  },
}));

type Props = {
  title: string,
  value: string,
  image?: string,
  imageAlt?: string,
  flex?: number,
  imageRotate?: string,
  iconComponent?: React.ReactNode,
  valueAddorment?: React.ReactNode,
  backgroundColor?: CSSProperties["backgroundColor"]
}

export const BalanceBox: React.FC<Props> = ({
  title,
  value,
  image,
  imageAlt,
  iconComponent,
  valueAddorment,
  imageRotate = "0deg",
  flex = 1,
  backgroundColor = "#FFFFFF"
}) => {
  const classes = useStyles({ flex, imageRotate, backgroundColor });
  return (
    <Paper className={clsx(classes.paper, classes.surface)}>
      <Box className={classes.titleContainer}>
        <Typography className={classes.title}>{title}</Typography>
        {image && <img className={classes.image} src={image} alt={imageAlt} color="green" />}
        {iconComponent && iconComponent}
      </Box>
      <Box className={classes.valueContainer}>
        <Typography className={classes.value}>{value}</Typography>
        {valueAddorment}
      </Box>
    </Paper>
  );
};
